import { types } from 'mobx-state-tree';
export var MaybeEmptyModel = function (ModelType) { return types.optional(ModelType, {}); };
